import parallel from 'async/parallel'
riot.tag2('delivery-regions', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Выберите город</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{parent.change.bind(this.parent)}">\n        <div class="form-group">\n          <label class="control-label">Страна</label>\n          <autocomplete name="idCountryTo" value-field="name" data="{parent.countries}" onchange="{parent.changeCountry.bind(this)}" min-symbols="2" value="{parent.item.idCountryTo}">{item.name}</autocomplete>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Регион</label>\n          <autocomplete name="idRegionTo" value-field="name" data="{parent.getRegions(tags.idCountryTo.value)}" __disabled="{tags.region.data.length == 0 &amp;&amp; tags.country.value == undefined}" onchange="{parent.changeRegion.bind(this)}" min-symbols="2" value="{parent.item.idRegionTo}">{item.name}</autocomplete>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Город</label>\n          <autocomplete name="idCityTo" value-field="name" data="{parent.cities}" __disabled="{tags.country.value == undefined}" min-symbols="2" value="{parent.item.idCityTo}">{item.name}</autocomplete>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('change');
self.cities = [];

self.getRegions = function (id) {
    if (self.regions instanceof Array && id !== undefined) return self.regions.filter(function (item) {
        return item.idCountry == id;
    });else return [];
};

self.changeCountry = function (e) {
    self.getCities(this.idCountryTo.value, this.idRegionTo.value);
};

self.changeRegion = function (e) {
    self.getCities(this.idCountryTo.value, this.idRegionTo.value);
};

self.getCities = function (country, region) {
    return API.request({
        object: 'GeoCity',
        method: 'Fetch',
        data: { idCountry: country, idRegion: region },
        success: function success(response) {
            self.cities = response.items;
            self.update();
        }
    });
};

self.on('mount', function () {
    var modal = self.tags['bs-modal'];
    modal.cannotBeClosed = true;
    modal.eChange = false;
    modal.close = function () {
        modal.modalHide();
    };

    self.item = {};

    if (opts.item) self.item = opts.item;

    parallel([function (callback) {
        API.request({
            object: 'GeoCountry',
            method: 'Fetch',
            success: function success(response) {
                self.countries = response.items;
                callback(null, 'Countries');
            },
            error: function error(response) {
                callback('error', null);
            }
        });
    }, function (callback) {
        API.request({
            object: 'GeoRegion',
            method: 'Fetch',
            success: function success(response) {
                self.regions = response.items;
                callback(null, 'Regions');
            },
            error: function error(response) {
                callback('error', null);
            }
        });
    }], function (err, res) {

        if (self.item.idCityTo != null && self.item.idCityTo > 0) {
            var ids = [self.item.idCityTo];

            API.request({
                object: 'GeoCity',
                method: 'Fetch',
                data: { ids: ids },
                success: function success(response) {
                    self.item.idCountryTo = response.items[0].idCountry;
                    self.item.idRegionTo = response.items[0].idRegion;

                    self.countries.forEach(function (item) {
                        if (item.id == self.item.idCountryTo) self.tags['bs-modal'].tags.idCountryTo.filterValue = item.name;
                    });

                    self.regions.forEach(function (item) {
                        if (item.id == self.item.idRegionTo) self.tags['bs-modal'].tags.idRegionTo.filterValue = item.name;
                    });

                    self.tags['bs-modal'].tags.idCityTo.filterValue = response.items[0].name;

                    self.loader = false;
                    self.update();
                }
            });
        } else {
            self.loader = false;
            self.update();
        }
    });
});
});


// WEBPACK FOOTER //
// ./pages/delivery/delivery-regions.tag